import { defineMessages } from 'react-intl';

export const wizardCostBreakdownMessages = defineMessages({
  title: {
    defaultMessage: 'Cost Breakdown',
    id: '1bKcgA',
    description: 'Header label for the cost breakdown section in the rates panel',
  },
  total: {
    defaultMessage: 'Total',
    id: 'qG6VOD',
    description: 'Label for the always-visible total row in the cost breakdown section',
  },
  disclaimer: {
    defaultMessage: 'Final amount may vary. Post-shipment adjustments are common with LTL. Invoice sent by WWEX after shipment.',
    id: 'HAJlN4',
    description: 'Disclaimer caption at the bottom of the cost breakdown section',
  },
  manageBilling: {
    defaultMessage: 'Manage your billing in SpeedShip',
    id: 'biuPSE',
    description: 'Inline link to manage billing in SpeedShip within the cost breakdown disclaimer',
  },

  // Freight
  chargeFreight: {
    defaultMessage: 'Freight',
    id: 'Z5GZV6',
    description: 'Cost breakdown charge label for the FRT / FREIGHT charge codes',
  },
  chargeFreightMinimum: {
    defaultMessage: 'Freight Minimum',
    id: 'pIjBvM',
    description: 'Cost breakdown charge label for the FREIGHT_MIN charge code',
  },
  chargeLineHaulSurcharge: {
    defaultMessage: 'Line Haul Surcharge',
    id: 'LOzfAD',
    description: 'Cost breakdown charge label for the LHS (line haul surcharge) charge code',
  },

  // Fuel
  chargeFuelSurcharge: {
    defaultMessage: 'Fuel Surcharge',
    id: 'F5JUlI',
    description: 'Cost breakdown charge label for the FSC / FSCNET / FUEL charge codes',
  },

  // Insurance / Declared Value
  chargeInsurance: {
    defaultMessage: 'Insurance',
    id: 'O5i3A6',
    description: 'Cost breakdown charge label shared by the INS and INSURANCE charge codes',
  },
  chargeDeclaredValueSurcharge: {
    defaultMessage: 'Declared Value Surcharge',
    id: 'YtIPK6',
    description: 'Cost breakdown charge label for the DVS charge code',
  },
  chargeExtendedValueSurcharge: {
    defaultMessage: 'Extended Value Surcharge',
    id: 'jl6FJF',
    description: 'Cost breakdown charge label for the EVS charge code',
  },

  // Hazardous material
  hazardousMaterialValueSurcharge: {
    defaultMessage: 'Hazardous material',
    id: '1NPt6v',
    description: 'Cost breakdown charge label for the hazardous material',
  },

  // Handling & Fees
  chargeCustomerHandlingCharge: {
    defaultMessage: 'Customer Handling Charge',
    id: 'esx4Nw',
    description: 'Cost breakdown charge label for the CHC (customer handling charge) charge code',
  },
  chargeCarbComplianceFee: {
    defaultMessage: 'Carb Compliance Fee',
    id: 'WcTjZq',
    description: 'Cost breakdown charge label for the CARBFEE charge code',
  },
  chargeCreditCardFee: {
    defaultMessage: 'Credit Card Fee',
    id: 'yc//nm',
    description: 'Cost breakdown charge label for the CARDFEE charge code',
  },
  chargeInvoiceProcessing: {
    defaultMessage: 'Invoice Processing',
    id: 'vzTCu6',
    description: 'Cost breakdown charge label for the INVPRCFEE charge code',
  },
  chargeNonSufficientFunds: {
    defaultMessage: 'Non-sufficient Funds',
    id: 'PvyMsH',
    description: 'Cost breakdown charge label for the NSFFEE charge code',
  },
  chargePaperInvoiceFee: {
    defaultMessage: 'Paper Invoice Fee',
    id: 'zMOh2F',
    description: 'Cost breakdown charge label for the PAPERFEE charge code',
  },
  chargeShippingHandlingFee: {
    defaultMessage: 'Shipping / Handling',
    id: 'IG+qIS',
    description: 'Cost breakdown charge label for the SHFFEE charge code',
  },
  chargeMarketingFund: {
    defaultMessage: 'Marketing Fund',
    id: 'X9GHIk',
    description: 'Cost breakdown charge label for the MARKETING_FUND_FEE charge code',
  },
  chargeTechHosting: {
    defaultMessage: 'Tech Hosting',
    id: '+dmZiK',
    description: 'Cost breakdown charge label for the USER_FEE charge code',
  },
  chargeTerritoryFee: {
    defaultMessage: 'Territory Fee',
    id: 'w3ID9k',
    description: 'Cost breakdown charge label for the TERRITORY_FEE charge code',
  },

  // Accessorials
  chargeAppointmentRequired: {
    defaultMessage: 'Appointment Required',
    id: 'DFBr1J',
    description: 'Cost breakdown charge label for the APPT charge code',
  },
  chargeCollectOnDelivery: {
    defaultMessage: 'Collect on Delivery',
    id: 'xQrwPt',
    description: 'Cost breakdown charge label for the COD charge code',
  },
  chargeGuaranteedDelivery: {
    defaultMessage: 'Guaranteed Delivery',
    id: 'Ir+d5u',
    description: 'Cost breakdown charge label shared by the GUR and GRDEL charge codes',
  },
  chargeSaturdayDelivery: {
    defaultMessage: 'Saturday Delivery',
    id: 'l/mHky',
    description: 'Cost breakdown charge label for the SAT charge code',
  },
  chargeSignatureRequired: {
    defaultMessage: 'Signature Required',
    id: 'H3iem9',
    description: 'Cost breakdown charge label for the SIGDEL charge code',
  },
  chargeInsidePickup: {
    defaultMessage: 'Inside Pickup',
    id: 'N/c3br',
    description: 'Cost breakdown charge label for the INPU charge code',
  },
  chargeInsideDelivery: {
    defaultMessage: 'Inside Delivery',
    id: 'R7qEKT',
    description: 'Cost breakdown charge label for the INDEL charge code',
  },
  chargeOversize: {
    defaultMessage: 'Oversize',
    id: 'LRy97L',
    description: 'Cost breakdown charge label for the OVDIM charge code',
  },
  chargeAdditionalHandlingDimensional: {
    defaultMessage: 'Additional Handling - Dimensional',
    id: 'ZvOGHi',
    description: 'Cost breakdown charge label for the AHC charge code',
  },
  chargeAdditionalHandlingWeight: {
    defaultMessage: 'Additional Handling - Weight',
    id: 'DZOeH+',
    description: 'Cost breakdown charge label for the AHW charge code',
  },
  chargeTrackingNumber: {
    defaultMessage: 'Tracking Number Charge',
    id: 'aWBrmB',
    description: 'Cost breakdown charge label for the TCKNU charge code',
  },
  chargeCertificateOfOrigin: {
    defaultMessage: 'Certificate of Origin',
    id: 'WPb9QJ',
    description: 'Cost breakdown charge label for the COO charge code',
  },
  chargeElectronicExportInfo: {
    defaultMessage: 'Electronic Export Information',
    id: '422vTR',
    description: 'Cost breakdown charge label for the 36 (EEI) charge code',
  },

  // Residential
  chargeResidentialSurcharge: {
    defaultMessage: 'Residential Surcharge',
    id: 'HPvhjG',
    description: 'Cost breakdown charge label shared by the HRS / RES / REP / PSR charge codes',
  },
  chargeResidentialDelivery: {
    defaultMessage: 'Residential Delivery',
    id: '/+sb6a',
    description: 'Cost breakdown charge label for the RESDEL charge code',
  },
  chargeSurgeFee: {
    defaultMessage: 'Surge Fee',
    id: 'sn8e2A',
    description: 'Cost breakdown charge label shared by the PFR and PFC charge codes',
  },

  // Liftgate
  chargeLiftgate: {
    defaultMessage: 'Liftgate',
    id: 'c1BZq5',
    description: 'Cost breakdown charge label for the LCC charge code',
  },
  chargeLiftgateDelivery: {
    defaultMessage: 'Liftgate Delivery',
    id: 'OhZO8i',
    description: 'Cost breakdown charge label for the LGDEL charge code',
  },
  chargeLiftgatePickup: {
    defaultMessage: 'Liftgate Pickup',
    id: '0ksKYo',
    description: 'Cost breakdown charge label shared by the LGPU and LGP charge codes',
  },
  chargeLiftgateBulk: {
    defaultMessage: 'Liftgate - Bulk',
    id: 'UeT6wb',
    description: 'Cost breakdown charge label for the LGBU charge code',
  },

  // High Cost / Remote Area
  chargeHighCostPickup: {
    defaultMessage: 'High Cost Pickup',
    id: '2Nc/D7',
    description: 'Cost breakdown charge label shared by the HCP / HCPA / HCFP charge codes',
  },
  chargeHighCostDelivery: {
    defaultMessage: 'High Cost Delivery',
    id: 'T1YtY8',
    description: 'Cost breakdown charge label shared by the HCD / HCDA / HCFD charge codes',
  },
  chargeIntlHighCostPickup: {
    defaultMessage: 'International High Cost Pickup',
    id: '01/Qub',
    description: 'Cost breakdown charge label for the IHCP charge code',
  },
  chargeIntlHighCostDelivery: {
    defaultMessage: 'International High Cost Delivery',
    id: 'EtZRVt',
    description: 'Cost breakdown charge label for the IHCD charge code',
  },
  chargeRemoteArea: {
    defaultMessage: 'Remote Area',
    id: 'N20BLi',
    description: 'Cost breakdown charge label for the HBR charge code',
  },
  chargeOverLimitSurcharge: {
    defaultMessage: 'Over-limit Surcharge',
    id: 'f+WEjI',
    description: 'Cost breakdown charge label for the OVR charge code',
  },
  chargeExcessMiles: {
    defaultMessage: 'Excess Miles Surcharge',
    id: '9LkeUX',
    description: 'Cost breakdown charge label for the EXCESSMILES charge code',
  },

  // Metro / Geographic
  chargeCongestedMetro: {
    defaultMessage: 'Congested Metro Area Surcharge',
    id: 'UhD/nJ',
    description: 'Cost breakdown charge label for the METRO charge code',
  },
  chargeFerrySurcharge: {
    defaultMessage: 'Ferry Surcharge',
    id: 'Eju3tf',
    description: 'Cost breakdown charge label for the FERRY charge code',
  },
  chargeMetroPickup: {
    defaultMessage: 'Metro Pickup Surcharge',
    id: 'ZpMY1e',
    description: 'Cost breakdown charge label for the METROPU charge code',
  },

  // Limited Access
  chargeLimitedAccess: {
    defaultMessage: 'Limited Access',
    id: 'L1pN0c',
    description: 'Cost breakdown charge label for the LTDACC charge code',
  },
  chargeLimitedAccessDelivery: {
    defaultMessage: 'Limited Access Delivery',
    id: 'GHhvNf',
    description: 'Cost breakdown charge label for the LTDDEL charge code',
  },
  chargeLimitedAccessPickup: {
    defaultMessage: 'Limited Access - Pickup',
    id: 'JBGTP9',
    description: 'Cost breakdown charge label for the LTDPU charge code',
  },

  // Miscellaneous
  chargeMiscellaneous: {
    defaultMessage: 'Miscellaneous',
    id: 'EdlUbS',
    description: 'Cost breakdown charge label for the MIS charge code',
  },
  chargeMiscSurcharge: {
    defaultMessage: 'Miscellaneous Surcharge',
    id: 'X9wWsP',
    description: 'Cost breakdown charge label for the MSC charge code',
  },
  chargeAccessorialSurcharge: {
    defaultMessage: 'Accessorial Surcharge',
    id: 'sbJEtY',
    description: 'Cost breakdown charge label for the ASC charge code',
  },
  chargeAdditionalSurcharge: {
    defaultMessage: 'Additional Surcharge',
    id: 'i73zLv',
    description: 'Cost breakdown charge label for the ADS charge code',
  },
  chargeAdditionalCharge: {
    defaultMessage: 'Additional Charge',
    id: 'BJFJNt',
    description: 'Cost breakdown charge label for the ADD charge code',
  },
  chargeCarrierSurcharge: {
    defaultMessage: 'Carrier Surcharge',
    id: 'cJgSfj',
    description: 'Cost breakdown charge label for the CSV charge code',
  },
  chargeDeliverySurcharge: {
    defaultMessage: 'Delivery Surcharge',
    id: 'n3XB+w',
    description: 'Cost breakdown charge label for the DCR charge code',
  },
  chargeAdvanceNotification: {
    defaultMessage: 'Advance Notification',
    id: 'sevQ/R',
    description: 'Cost breakdown charge label for the NOTIFY charge code',
  },
  chargeHoldForPickup: {
    defaultMessage: 'Hold for Pickup',
    id: 'wuUmVJ',
    description: 'Cost breakdown charge label for the HOLD charge code',
  },
  chargeSingleShipment: {
    defaultMessage: 'Single Shipment',
    id: 'Gtfauk',
    description: 'Cost breakdown charge label for the SINGSHIP charge code',
  },
  chargeSortSegregate: {
    defaultMessage: 'Sort / Segregate',
    id: 'w6X1tm',
    description: 'Cost breakdown charge label for the SORT charge code',
  },
  chargeCarbonSurcharge: {
    defaultMessage: 'Carbon Surcharge',
    id: 'dWBQ2x',
    description: 'Cost breakdown charge label for the CARBON charge code',
  },
  chargeCalCleanAir: {
    defaultMessage: 'California Clean Air Surcharge',
    id: '+aSpVK',
    description: 'Cost breakdown charge label for the CAL_CLEAN_AIR charge code',
  },
  chargeBorderProcessing: {
    defaultMessage: 'Border Processing',
    id: 'K7AFrK',
    description: 'Cost breakdown charge label for the BORDER_PROCESSING charge code',
  },
  chargeDocumentFee: {
    defaultMessage: 'Document Fee',
    id: 'GqAl5y',
    description: 'Cost breakdown charge label for the DOCFEE charge code',
  },
  chargeMigRevShare: {
    defaultMessage: 'Migration Revenue Share',
    id: '5SDtuV',
    description: 'Cost breakdown charge label for the MIG_REV_SHARE charge code',
  },

  // Franchise / Royalty
  chargeRoyaltyExpressTotalMargin: {
    defaultMessage: 'Royalty - Express Total Margin',
    id: 'IgBWND',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_TOTAL_EXP_MARGIN charge code',
  },
  chargeRoyaltyExpressSalePrice: {
    defaultMessage: 'Royalty - Express Sale Price',
    id: '80j07q',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_TOTAL_EXP_SALE_PRICE charge code',
  },
  chargeRoyaltyExpressCharge: {
    defaultMessage: 'Royalty - Express Charge',
    id: '3TdGy3',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_EXPRESS_CHARGE charge code',
  },
  chargeRoyaltyFreightTotalMargin: {
    defaultMessage: 'Royalty - Freight Total Margin',
    id: 'LhzaB5',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_TOTAL_FREIGHT_MARGIN charge code',
  },
  chargeRoyaltyFreightSalePrice: {
    defaultMessage: 'Royalty - Freight Sale Price',
    id: 'QhkdWb',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_TOTAL_FREIGHT_SALE_PRICE charge code',
  },
  chargeRoyaltyFreightCharge: {
    defaultMessage: 'Royalty - Freight',
    id: '/VFLON',
    description: 'Cost breakdown charge label for the FRANCHISE_ROYALTY_FREIGHT_CHARGE charge code',
  },
  chargeRoyaltyMinimum: {
    defaultMessage: 'Royalty - Minimum Charge',
    id: 'YGt6o6',
    description: 'Cost breakdown charge label for the FRANCHISE_MINIMUM_ROYALTY_CHARGE charge code',
  },
  chargeRoyaltyTotal: {
    defaultMessage: 'Royalty - Total',
    id: 'Btgno4',
    description: 'Cost breakdown charge label for the FRANCHISE_TOTAL_ROYALTY_CHARGE charge code',
  },

  // Carrier Numeric Codes (UPS)
  chargeUps: {
    defaultMessage: 'UPS',
    id: 'uX3ciY',
    description: 'Cost breakdown charge label for UPS numeric charge codes (206, 235, 341, 351, 400, 405, 410, 426, 619)',
  },
});
